module.exports = __webpack_public_path__ + "static/media/zoomlifestyle.b8e33d6e.png";